import { CurrencySymbol } from 'shared/constants/currency';
import { SubscriptionPlanResponse } from 'shared/types/Subscription';

export const getFormattedPrice = (
    plan: SubscriptionPlanResponse | null,
): string =>
    plan
        ? `${CurrencySymbol[plan.currency_code.toLowerCase()]}${Number(
              plan.price,
          )}`
        : '-';
